// Accessibility Helpers
// ---------------------
// A collection of utility functions to help make your site more accessible

// Add titles to all iframes
function addIframeTitles() {
  var iframes = document.querySelectorAll('iframe');
  iframes.forEach(function(iframe) {
    var title = iframe.getAttribute('title') || 'Iframe';
    iframe.setAttribute('title', title);
  });
}

// On page load, run addIframeTitles
document.addEventListener('DOMContentLoaded', addIframeTitles);